export default __webpack_public_path__ + "static/media/icon-link.d25d108e.svg";